import { render, staticRenderFns } from "./vip-regular.vue?vue&type=template&id=56cadd7e&scoped=true"
import script from "./vip-regular.vue?vue&type=script&lang=js"
export * from "./vip-regular.vue?vue&type=script&lang=js"
import style0 from "./vip-regular.vue?vue&type=style&index=0&id=56cadd7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cadd7e",
  null
  
)

export default component.exports